import isAccountRegisterUrlLocationUtil from 'utils/location/is-account-register-url'
import isAccountLoginUrlLocationUtil from 'utils/location/is-account-login-url'
import isPostSampleSurveyUrlLocationUtil from 'utils/location/is-post-sample-survey'
import isCartUrlLocationUtil from 'utils/location/is-cart-url'

export default function shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil () {
  if (isPostSampleSurveyUrlLocationUtil()) {
    logUtil('shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil').debug('[noop] post sample survey')
    return false
  }

  if (isCartUrlLocationUtil()) {
    logUtil('shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil').debug('[noop] cart')
    return false
  }

  if (isAccountRegisterUrlLocationUtil() || isAccountLoginUrlLocationUtil()) {
    logUtil('shouldShowModalOrBannerBasedOnLocationPostSampleSurveyUtil').debug('[noop] account register or login')
    return false
  }

  return true
}
